import React from 'react';
import fallbackLogo from '../assets/images/logo_1.svg';
import fallbackStar from '../assets/images/star.svg';

function CasinoCard({ casino }) {
  // Handle image errors with fallback
  const handleImageError = (e) => {
    e.target.src = fallbackLogo;
  };

  return (
    <a href={casino.url || '#'} target="_blank" rel="noopener noreferrer">
      <div className="boxContainer mb-30 wow animate__ animate__backInUp animated">
        <div className="row">
          <div className="col-md-2 mob-flex">
            {casino.image ? (
              <img 
                src={casino.image} 
                alt={casino.name} 
                className="imgBox" 
                onError={handleImageError}
              />
            ) : (
              <div className="imgBox" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                backgroundColor: '#fff',
                color: '#000'
              }}>
                <span>No Image</span>
              </div>
            )}
            <p className="boxTitile mob-title f-white f-34 w-700 mb-10" style={{ textTransform: 'capitalize' }}>
              {casino.name}
            </p>
          </div>
          <div className="col-md-8">
            <div className="leftGrid">
              <div className="titleSection">
                <p className="boxTitile f-white f-34 w-700 mb-10" style={{ textTransform: 'capitalize' }}>
                  {casino.name}
                </p>
              </div>
              <div className="paraTextWidth mb-20">
                <p className="getPara f-18 w-400 f-white">
                  {casino.description || 'No description available.'}
                </p>
              </div>
              <div className="rightButton">
                <span className="btn-purple f-black f-16 w-600">Play Now</span>
              </div>
            </div>
          </div>
          <div className="col-md-2">
            <div className="rating">
              <p className="f-16 w-700">Next Score</p>
              <p>
                <img 
                  src={casino.starImage} 
                  alt="star" 
                  className="starImg"
                  onError={(e) => {
                    e.target.src = fallbackStar;
                  }}
                />
              </p>
              <p className="f-18 w-500">
                {casino.rating ? (parseFloat(casino.rating).toFixed(1)) : '0.0'} / 5
              </p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
}

export default CasinoCard;
